import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../api/api";
import Swal from "sweetalert2";
import "./AdminDashboard.css";

const EditSubcategory = () => {
  const { schemeId, categoryName, subName } = useParams();
  const [subcategory, setSubcategory] = useState({
    name: "",
    applyLink: "",
    youtubeLink: "",
  });

  useEffect(() => {
    const fetchSubcategory = async () => {
      try {
        const res = await API.get(`/schemes/${schemeId}`);
        const scheme = res.data;

        const category = scheme.categories.find(
          (cat) => cat.name === decodeURIComponent(categoryName)
        );
        if (!category) {
          Swal.fire("Error", "Category not found", "error");
          return;
        }

        const sub = category.subcategories.find(
          (s) => s.name === decodeURIComponent(subName)
        );

        if (sub) {
          setSubcategory({
            name: sub.name || "",
            applyLink: sub.applyLink || "",
            youtubeLink: sub.youtubeLink || "",
          });
        } else {
          Swal.fire("Error", "Subcategory not found", "error");
        }
      } catch (err) {
        console.error("Error fetching subcategory:", err);
        Swal.fire("Error", "Failed to load subcategory", "error");
      }
    };

    fetchSubcategory();
  }, [schemeId, categoryName, subName]);

  const handleChange = (field, value) => {
    setSubcategory({ ...subcategory, [field]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Confirm before saving
    const confirm = await Swal.fire({
      title: "Save Changes?",
      text: "Do you want to update this subcategory?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      await API.put(`/schemes/${schemeId}`, {
        categoryName: decodeURIComponent(categoryName),
        oldSubName: decodeURIComponent(subName),
        subcategory,
      });

      await Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Subcategory updated successfully.",
        timer: 1500,
        showConfirmButton: false,
      });

      window.history.back();
    } catch (err) {
      console.error("Error updating subcategory:", err);
      Swal.fire("Error", "Failed to update subcategory", "error");
    }
  };

  const handleCancel = async () => {
    const confirm = await Swal.fire({
      title: "Cancel changes?",
      text: "Your unsaved changes will be lost.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, go back",
    });
    if (confirm.isConfirmed) window.history.back();
  };

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-card shadow-lg">
        <h3 className="dashboard-title mb-3">Edit Service Action</h3>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Service Action Name</label>
            <input
              type="text"
              className="form-control input-box"
              value={subcategory.name}
              onChange={(e) => handleChange("name", e.target.value)}
              placeholder="Enter Service Action name"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Apply Link</label>
            <input
              type="text"
              className="form-control input-box"
              value={subcategory.applyLink}
              onChange={(e) => handleChange("applyLink", e.target.value)}
              placeholder="Enter apply link"
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">YouTube Link</label>
            <input
              type="text"
              className="form-control input-box"
              value={subcategory.youtubeLink}
              onChange={(e) => handleChange("youtubeLink", e.target.value)}
              placeholder="Enter YouTube tutorial link"
            />
          </div>

          <div className="d-flex gap-3 mt-4">
            <button type="submit" className="btn save-btn">
              💾 Save Changes
            </button>
            <button
              type="button"
              className="btn cancel-btn"
              onClick={handleCancel}
            >
              ❌ Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSubcategory;
